import { render, staticRenderFns } from "./Occurrences.vue?vue&type=template&id=d90b7200&"
import script from "./Occurrences.vue?vue&type=script&lang=ts&"
export * from "./Occurrences.vue?vue&type=script&lang=ts&"
import style0 from "./Occurrences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports